import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { apiFetch } from '../../utils/api';

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const PRI = {
  critical: ['#991b1b', '#fee2e2'], high: ['#c2410c', '#ffedd5'],
  medium: ['#b45309', '#fef3c7'], low: ['#166534', '#f0fdf4'],
};
const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
const CSS = `
.tcal *{box-sizing:border-box}
.tcal{--line:#E8ECF2;--line2:#eef1f6;--t1:#0F172A;--t2:#64748B;--t3:#94A3B8;--kg:#0B6623;--kg50:#f0fdf4;
  --raised:#2563EB;--raised-bg:#EFF4FF;--closed:#0B6623;--closed-bg:#EDFaef;
  --sh:0 1px 2px rgba(16,24,40,.04),0 1px 3px rgba(16,24,40,.06);}
.tcal .kpi{background:var(--bg-surface);border:1px solid var(--line);border-radius:14px;padding:10px 16px;box-shadow:var(--sh);min-width:96px;}
.tcal .kpi .n{font-size:22px;font-weight:800;letter-spacing:-.5px;line-height:1;}
.tcal .kpi .l{font-size:11px;font-weight:600;color:var(--t2);margin-top:4px;display:flex;align-items:center;gap:5px;}
.tcal .toolbar{display:flex;align-items:center;gap:12px;flex-wrap:wrap;background:var(--bg-surface);border:1px solid var(--line);
  border-radius:16px;padding:12px 14px;box-shadow:var(--sh);margin-bottom:18px;}
.tcal .seg{display:inline-flex;background:#eef1f6;border-radius:11px;padding:3px;gap:2px;}
.tcal .seg button{border:none;background:none;padding:8px 15px;border-radius:9px;font-size:13px;font-weight:600;color:var(--t2);cursor:pointer;transition:.15s;}
.tcal .seg button.on{background:#fff;color:var(--kg);box-shadow:0 1px 3px rgba(16,24,40,.12);font-weight:700;}
.tcal select{appearance:none;-webkit-appearance:none;font-family:inherit;font-size:13.5px;font-weight:600;color:var(--t1);
  padding:9px 32px 9px 13px;border:1.5px solid var(--line);border-radius:11px;background:#fff;cursor:pointer;
  background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
  background-repeat:no-repeat;background-position:right 11px center;background-size:11px;}
.tcal .divider{width:1px;height:26px;background:var(--line);}
.tcal .nav{width:34px;height:34px;border-radius:10px;border:1.5px solid var(--line);background:#fff;cursor:pointer;font-size:16px;color:var(--t2);}
.tcal .nav:hover{border-color:var(--kg);color:var(--kg);}
.tcal .today-btn{padding:8px 14px;border-radius:10px;border:1.5px solid var(--line);background:#fff;font-weight:700;font-size:13px;cursor:pointer;color:var(--t1);}
.tcal .legend{display:flex;gap:14px;font-size:12px;color:var(--t2);align-items:center;}
.tcal .dot{width:10px;height:10px;border-radius:3px;}
.tcal .wrap{display:flex;gap:18px;align-items:flex-start;}
.tcal .cal{flex:1;background:var(--bg-surface);border:1px solid var(--line);border-radius:18px;box-shadow:var(--sh);overflow:hidden;}
.tcal .dow{display:grid;grid-template-columns:repeat(7,1fr);border-bottom:1px solid var(--line);}
.tcal .dow div{padding:12px 14px;font-size:11px;font-weight:700;color:var(--t3);text-transform:uppercase;letter-spacing:.7px;}
.tcal .grid{display:grid;grid-template-columns:repeat(7,1fr);}
.tcal .cell{min-height:104px;border-right:1px solid var(--line2);border-bottom:1px solid var(--line2);padding:9px 10px;
  cursor:pointer;position:relative;transition:.12s;display:flex;flex-direction:column;gap:6px;}
.tcal .cell:nth-child(7n){border-right:none;}
.tcal .cell.wknd{background:#fafbfd;}
.tcal .cell.out{background:#fbfcfe;cursor:default;}
.tcal .cell:hover:not(.out){background:#f6f9fb;box-shadow:inset 0 0 0 1.5px var(--line);}
.tcal .cell.sel{box-shadow:inset 0 0 0 2px var(--kg);background:var(--kg50);}
.tcal .num{font-size:13px;font-weight:700;color:var(--t2);width:26px;height:26px;display:inline-flex;align-items:center;justify-content:center;}
.tcal .cell.today .num{background:var(--kg);color:#fff;border-radius:50%;box-shadow:0 2px 6px rgba(11,102,35,.3);}
.tcal .cell.out .num{color:#cdd5e0;}
.tcal .counts{margin-top:auto;display:flex;flex-direction:column;gap:4px;}
.tcal .cnt{display:flex;align-items:center;gap:6px;font-size:11.5px;font-weight:700;padding:3px 8px;border-radius:7px;line-height:1;}
.tcal .cnt.r{background:var(--raised-bg);color:var(--raised);}
.tcal .cnt.c{background:var(--closed-bg);color:var(--closed);}
.tcal .cnt .d{width:7px;height:7px;border-radius:50%;}
.tcal .panel{width:320px;flex-shrink:0;background:var(--bg-surface);border:1px solid var(--line);border-radius:18px;box-shadow:var(--sh);position:sticky;top:20px;overflow:hidden;}
.tcal .ph{padding:18px 18px 14px;background:linear-gradient(135deg,#0B6623,#149a3b);color:#fff;}
.tcal .ph h3{margin:0;font-size:16px;font-weight:700;}
.tcal .ph .ps{font-size:12.5px;opacity:.92;margin-top:3px;}
.tcal .pbody{padding:14px 16px 18px;max-height:62vh;overflow:auto;}
.tcal .sechead{font-size:11px;font-weight:800;letter-spacing:.5px;text-transform:uppercase;margin:4px 0 8px;display:flex;align-items:center;gap:6px;}
.tcal .sechead.c{margin-top:16px;}
.tcal .tk{border:1px solid var(--line);border-radius:11px;padding:10px 12px;margin-bottom:8px;transition:.12s;cursor:pointer;}
.tcal .tk:hover{border-color:var(--kg);box-shadow:var(--sh);}
.tcal .mono{font-family:ui-monospace,Menlo,monospace;font-size:11px;color:var(--t3);font-weight:600;}
.tcal .chip{font-size:9.5px;font-weight:800;padding:2px 8px;border-radius:99px;text-transform:uppercase;letter-spacing:.3px;}
.tcal .tt{font-size:13px;font-weight:500;margin-top:5px;color:var(--t1);}
.tcal .meta{font-size:11px;color:var(--t2);margin-top:4px;display:flex;gap:10px;flex-wrap:wrap;}
.tcal .empty{font-size:12px;color:var(--t3);padding:6px 0 2px;}
.tcal .ph-empty{padding:40px 20px;text-align:center;color:var(--t3);}
@media(max-width:860px){.tcal .wrap{flex-direction:column}.tcal .panel{width:100%;position:static}.tcal .cell{min-height:88px}}
`;

export default function TicketCalendar() {
  const nav = useNavigate();
  const location = useLocation();
  const basePath = location.pathname.startsWith('/manager') ? '/manager/tickets' : '/admin/tickets';
  const today = new Date();
  const todayKey = ymd(today);

  const [view, setView] = useState(new Date(today.getFullYear(), today.getMonth(), 1));
  const [scope, setScope] = useState('all');
  const [who, setWho] = useState('');
  const [show, setShow] = useState('both');
  const [sel, setSel] = useState(null);
  const [data, setData] = useState({ raised: [], closed: [] });
  const [filters, setFilters] = useState({ agents: [], customers: [] });

  useEffect(() => { apiFetch('/analytics/ticket-calendar/filters').then(setFilters).catch(() => {}); }, []);

  const load = useCallback(() => {
    const y = view.getFullYear(), m = view.getMonth() + 1;
    let q = `?year=${y}&month=${m}&scope=${scope}`;
    if (scope === 'agent' && who) q += `&agent=${encodeURIComponent(who)}`;
    if (scope === 'customer' && who) q += `&customer=${encodeURIComponent(who)}`;
    apiFetch(`/analytics/ticket-calendar${q}`).then(d => setData({ raised: d.raised || [], closed: d.closed || [] })).catch(() => setData({ raised: [], closed: [] }));
  }, [view, scope, who]);
  useEffect(() => { load(); }, [load]);

  const bucket = (list) => { const m = {}; list.forEach(t => { (m[t.day] = m[t.day] || []).push(t); }); return m; };
  const raisedBy = bucket(data.raised);
  const closedBy = bucket(data.closed);

  const changeScope = (s) => { setScope(s); setWho(''); setSel(null); };
  const y = view.getFullYear(), m = view.getMonth();
  const startDow = (new Date(y, m, 1).getDay() + 6) % 7;
  const dim = new Date(y, m + 1, 0).getDate();
  const years = []; for (let yy = today.getFullYear() - 4; yy <= today.getFullYear() + 1; yy++) years.push(yy);

  const selRaised = sel ? (raisedBy[sel] || []) : [];
  const selClosed = sel ? (closedBy[sel] || []) : [];

  const TicketCard = (t) => {
    const ps = PRI[t.priority] || ['#64748b', '#f1f5f9'];
    return (
      <div key={t.id + t.day} className="tk" onClick={() => nav(`${basePath}/${t.id}`)} title="Open ticket">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
          <span className="mono">{t.ticket_number || t.id}</span>
          <span className="chip" style={{ background: ps[1], color: ps[0] }}>{t.priority}</span>
        </div>
        <div className="tt">{t.title}</div>
        <div className="meta"><span>👤 {t.agent_name || 'Unassigned'}</span><span>🏢 {t.customer_name || '—'}</span></div>
      </div>
    );
  };

  return (
    <div className="page tcal" style={{ padding: '26px 30px', maxWidth: 1280, margin: '0 auto' }}>
      <style>{CSS}</style>

      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap', marginBottom: 20 }}>
        <div>
          <div className="page-title">Ticket Calendar</div>
          <div className="page-sub">Tickets raised &amp; closed each day — filter by everyone, an agent, or a customer</div>
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <div className="kpi"><div className="n" style={{ color: 'var(--raised)' }}>{data.raised.length}</div><div className="l"><span className="dot" style={{ background: 'var(--raised)' }} />Raised this month</div></div>
          <div className="kpi"><div className="n" style={{ color: 'var(--closed)' }}>{data.closed.length}</div><div className="l"><span className="dot" style={{ background: 'var(--closed)' }} />Closed this month</div></div>
        </div>
      </div>

      <div className="toolbar">
        <div className="seg">
          {[['all', 'All'], ['agent', 'By Agent'], ['customer', 'By Customer']].map(s => (
            <button key={s[0]} className={scope === s[0] ? 'on' : ''} onClick={() => changeScope(s[0])}>{s[1]}</button>
          ))}
        </div>
        {scope !== 'all' && (
          <select value={who} onChange={e => { setWho(e.target.value); setSel(null); }}>
            <option value="">All {scope === 'agent' ? 'agents' : 'customers'}</option>
            {scope === 'agent'
              ? filters.agents.map(a => <option key={a.id} value={a.id}>{a.name}</option>)
              : filters.customers.map(c => <option key={c} value={c}>{c}</option>)}
          </select>
        )}
        <div className="divider" />
        <div className="seg">
          {[['both', 'Raised + Closed'], ['raised', 'Raised'], ['closed', 'Closed']].map(s => (
            <button key={s[0]} className={show === s[0] ? 'on' : ''} onClick={() => setShow(s[0])}>{s[1]}</button>
          ))}
        </div>
        <span style={{ flex: 1 }} />
        <button className="nav" onClick={() => { setView(new Date(y, m - 1, 1)); setSel(null); }}>‹</button>
        <select value={m} onChange={e => { setView(new Date(y, +e.target.value, 1)); setSel(null); }}>
          {MONTHS.map((mm, i) => <option key={i} value={i}>{mm}</option>)}
        </select>
        <select value={y} onChange={e => { setView(new Date(+e.target.value, m, 1)); setSel(null); }}>
          {years.map(yy => <option key={yy} value={yy}>{yy}</option>)}
        </select>
        <button className="nav" onClick={() => { setView(new Date(y, m + 1, 1)); setSel(null); }}>›</button>
        <button className="today-btn" onClick={() => { setView(new Date(today.getFullYear(), today.getMonth(), 1)); setSel(todayKey); }}>Today</button>
      </div>

      <div className="wrap">
        <div className="cal">
          <div className="dow">{['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map(d => <div key={d}>{d}</div>)}</div>
          <div className="grid">
            {Array.from({ length: startDow }).map((_, i) => <div key={'o' + i} className="cell out" />)}
            {Array.from({ length: dim }).map((_, i) => {
              const day = i + 1;
              const d = new Date(y, m, day);
              const k = ymd(d);
              const dow = d.getDay();
              const r = (raisedBy[k] || []).length, c = (closedBy[k] || []).length;
              const cls = ['cell', (dow === 0 || dow === 6) ? 'wknd' : '', k === todayKey ? 'today' : '', k === sel ? 'sel' : ''].filter(Boolean).join(' ');
              return (
                <div key={k} className={cls} onClick={() => setSel(k)}>
                  <span className="num">{day}</span>
                  <div className="counts">
                    {(show === 'both' || show === 'raised') && r > 0 && <span className="cnt r"><span className="d" style={{ background: 'var(--raised)' }} />{r} raised</span>}
                    {(show === 'both' || show === 'closed') && c > 0 && <span className="cnt c"><span className="d" style={{ background: 'var(--closed)' }} />{c} closed</span>}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="panel">
          {!sel ? (
            <div className="ph-empty">
              <div style={{ fontSize: 30, marginBottom: 8 }}>🗓️</div>
              <div style={{ fontWeight: 700, color: 'var(--t2)' }}>Pick a day</div>
              <div style={{ fontSize: 12, marginTop: 4 }}>Click any date to see the tickets raised and closed that day.</div>
            </div>
          ) : (
            <>
              <div className="ph">
                <h3>{new Date(sel + 'T00:00:00').toLocaleDateString('en-IN', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' })}</h3>
                <div className="ps">{selRaised.length} raised · {selClosed.length} closed{scope !== 'all' && who ? ` · ${scope === 'agent' ? (filters.agents.find(a => a.id === who) || {}).name || '' : who}` : ''}</div>
              </div>
              <div className="pbody">
                {(show === 'both' || show === 'raised') && <>
                  <div className="sechead" style={{ color: 'var(--raised)' }}><span className="dot" style={{ background: 'var(--raised)' }} />Raised ({selRaised.length})</div>
                  {selRaised.length ? selRaised.map(TicketCard) : <div className="empty">No tickets raised.</div>}
                </>}
                {(show === 'both' || show === 'closed') && <>
                  <div className="sechead c" style={{ color: 'var(--closed)' }}><span className="dot" style={{ background: 'var(--closed)' }} />Closed ({selClosed.length})</div>
                  {selClosed.length ? selClosed.map(TicketCard) : <div className="empty">No tickets closed.</div>}
                </>}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
